import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../home.css';
import RobotSvg from "../../../images/robotcute.svg";

const Home = () => {

  return (
    <div className='introContainer'>
      <Container fluid>
        <Row>
          <Col xs={12} md={7} style={{ float: 'left' }}>
            <h1 className='introTitle'>
              RIOT labs&nbsp; &nbsp;
            </h1>
            <h6>
              Part of Capgemini AIE
            </h6>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} md={8} style={{ float: 'left' }}>
            <h3>
              The Capgemini Rapid Innovation & Operations team&nbsp;
            </h3>
            <p>
              RIOT Labs is a space within the Applied Innovation Exchange (AIE) Nordics in Malmö,
              dedicated to exploring and implementing cutting-edge technology to drive innovative
              solutions and produce demonstrable assets. We initiate and host a range of projects
              that colleagues can join to boost their skills and CVs.
            </p>
          </Col>
          <Col xs={8} md={4} lg={3} className="d-flex align-items-end justify-content-end">
            <svg width="100%" viewBox="0 0 305 305">
              <image href={RobotSvg} />
            </svg>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
